<template>
  <div class="d-flex justify-content-end align-items-center">
    <ConversationButton />
    <span
      class="playhera-icon mx-4 cursor-pointer"
      @click.prevent="
        $event =>
          openSharingMenu({
            event: $event,
            type: clanAccount._type,
            text: `${$filters.displayName(clanAccount)} ${$t(
              '_web_' + clanAccount._type,
              clanAccount._type
            )} on `,
            id: clanAccount._id,
            vanityId: clanAccount.vanityId,
          })
      "
    >
      <AppIcon name="share" />
    </span>
    <button
      type="button"
      class="btn-transparent p-2 cursor-pointer text-secondary"
      @click="setActionPopover($event)"
    >
      <AppIcon name="dots" />
    </button>
    <PopoverMenu
      :closest="$el"
      target-selector="svg"
      :position="actionPopoverPosition"
      :items="statusBarMenuItems"
      :float="['right', 'top']"
    >
      <template slot-scope="{ item }">
        <span
          :class="{ 'text-danger': item.isDanger }"
          @click="hideActionPopover(item.action)"
          >{{ item.text || item.textCall(clanAccount) }}</span
        >
      </template>
    </PopoverMenu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { follow } from '@/mixins/accountActions/clan';
import PopoverMenu from '@/components/popover/Menu';
import AppIcon from '@/components/atoms/Icon';
import ConversationButton from '@/views/account/header/statusBar/default/ConversationButton';
import { sharingMenu } from '@/mixins/sharingMenu';
export default {
  name: 'AccountStatusBarActionsClanMember',
  components: {
    ConversationButton,
    PopoverMenu,
    AppIcon,
  },
  mixins: [follow, sharingMenu],
  data() {
    return {
      actionPopoverPosition: null,
      isCaptain: false,
      myTeams: [],
    };
  },
  computed: {
    ...mapState('current', {
      clanAccount: 'account',
      clanId: 'accountId',
    }),
    ...mapState('my', {
      myAccount: 'account',
      myAccountId: 'accountId',
    }),
    isOwner() {
      return this.clanAccount.role === 'owner';
    },
    isLastMemberInClan() {
      return this.clanAccount.membersCount === 1;
    },
    statusBarMenuItems() {
      return [
        {
          textCall: this.followClanText,
          action: this.followClanAction,
        },
        {
          text: this.$t('_web_clan_leave-clan', 'Leave clan'),
          action: this.clanLeaveAction,
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      'cancelUserFromMyClan',
      'errorNotify',
      'fetchClanCaptainsTeam',
      'openModal',
      'closeModal',
    ]),
    ...mapActions('my', ['fetchMyAccount']),
    hideActionPopover(callback) {
      this.actionPopoverPosition = null;
      if (typeof callback === 'function') {
        callback(this.clanAccount);
      }
    },
    setActionPopover(event) {
      this.actionPopoverPosition = event.target
        .closest('button')
        .getBoundingClientRect();
    },
    getTeams() {
      this.fetchClanCaptainsTeam(this.clanId)
        .then(res => {
          this.isCaptain = !!res.length;
          this.myTeams = res;
        })
        .then(() => {
          this.clanLeaveConfirm();
        })
        .catch(this.errorNotify);
    },
    clanLeaveAction() {
      this.getTeams();
    },
    clanLeaveConfirm() {
      if (this.isOwner || this.isCaptain) {
        if (this.isLastMemberInClan) {
          this.openModal({
            name: 'HeraConfirm',
            props: {
              text: this.$t(
                '_web_clan-leave-text',
                'You cant leave clan in owner role. You have to delete your owner role to another clan member'
              ),
              confirmButtonText: this.$t('_web_clan-leave_confirm-ok', 'OK'),
            },
            events: {
              cancel: this.closeModal,
              confirm: () => {
                this.closeModal();
              },
            },
          });
        } else {
          this.openModal({
            name: 'ClanLeaveConfirm',
            props: {
              isOwner: this.isOwner,
              isCaptain: this.isCaptain,
              myTeams: this.myTeams,
            },
          });
        }
      } else {
        this.openModal({
          name: 'HeraConfirm',
          props: {
            text: this.$t(
              '_web_clan-leave_text',
              'Do you want to leave {name}?',
              this.clanAccount
            ),
            confirmButtonText: this.$t(
              '_web_clan-leave_confirm-button',
              'Leave'
            ),
          },
          events: {
            cancel: this.closeModal,
            confirm: () => {
              this.closeModal();
              this.removeFromClan();
            },
          },
        });
      }
    },
    removeFromClan() {
      this.cancelUserFromMyClan({
        clanID: this.clanId,
        login: this.myAccountId,
      })
        .then(this.fetchMyAccount)
        .then(() => {
          this.$router.push({ name: 'clans' });
        })
        .catch(this.errorNotify);
    },
  },
};
</script>
